module.exports = __webpack_public_path__ + "img/johan-pro.239ef556.jpg";